import { useMemo, useRef } from 'react'

import { getScrollParent, type ScrollParent } from './getScrollParent'

export { scrollIntoViewScrollParent } from './scrollIntoViewScrollParent'
export { scrollToTopScrollParent } from './scrollToTopScrollParent'

export type { ScrollParent }
export { getScrollParent }

type RefType = {
	(element: HTMLElement | null): void
	readonly current: ScrollParent | undefined
}

export const useScrollParentRef = () => {
	const ref = useRef<ScrollParent>()

	return useMemo<RefType>(() => {
		const refFunction = (element: HTMLElement | null) => {
			ref.current = element ? getScrollParent(element) : undefined
		}

		Object.defineProperty(refFunction, 'current', {
			get() {
				return ref.current
			},
		})

		return refFunction as any
	}, [])
}
